const _ = require('lodash');

import { WindowUsercentricsService } from './utilities/window-usercentrics.service';
import { AnchorTagService } from './utilities/anchor-tags.service';
import { CustomEmbedService } from './utilities/custom-embed.service';
import { TagLoggerService } from './utilities/tag-logger.service';
import { UserAgentService } from './utilities/user-agent.service';
import { MoreInfoEventsService } from './utilities/more-info-events-service';
import { LanguageDeciderService } from './utilities/language-decider.service';
import { OptinTeimeoutService } from './utilities/optin-timeout.service';
import { CustomFunctionsService } from './utilities/custom-functions.service';
import { BgOverlayService } from './utilities/bg-overlay.service';
import { BannerListenerService } from './utilities/banner-listener.service';
import { HistoryLabelService } from './consents-services/history-label.service';
import { ConsentsStatusService } from './consents-services/consents-status.service';
import { ConsentsToggleService } from './consents-services/consents-toggle-detail.service';
import { GetConsentsService } from './consents-services/get-consents.service';
import { InitializeConsentsService } from './consents-services/initialize-consents.service';
import { SaveConsentsService } from './consents-services/save-consents.service';
import { CDCSyncService } from './consents-services/cdc-sync.service';
import { SettingsService } from './settings-service';
import { ApiService } from './api-service';

import LanguageService from '../ui-components/directives/laguage-service/language-service';
import CmpIABService from './cmp-iab-service';
import CmpJSApi from './cmp-js-api';
import CrossDomainConsentSharingService from './cdcs.service';
import { DataService } from './utilities/data.service';

require('data-layer-helper/dist/data-layer-helper');
/**
 * This class provide various utility functions for the application.
 */
export class UtilityService {
    public cDCSyncService: CDCSyncService;
    public consentsStatusService: ConsentsStatusService;
    public consentsToggleService: ConsentsToggleService;
    public getConsentsService: GetConsentsService;
    public historyLabelService: HistoryLabelService;
    public initializeConsentsService: InitializeConsentsService;
    public isDevelopmentMode: boolean = false;
    public saveConsentsService: SaveConsentsService;
    private isTagExecuted: {[tag: string]: boolean} = {};

    // other services and controller used in utility
    private _settingsService: SettingsService;
    private _ucViewController: any = {
        updateView: () => { }
    };
    private _languageService: any;
    private _apiService: ApiService;

    // utility services
    private _anchorTagService: any;
    private _customEmbedService: any;
    private _tagLoggerService: any;
    private _userAgentService: any;
    private _moreInfoEventsService: MoreInfoEventsService;
    private _languageDeciderService: LanguageDeciderService;
    private _optinTeimeoutService: OptinTeimeoutService;
    private _customFunctionsService: CustomFunctionsService;

    private _bgOverlayService: BgOverlayService;
    private _bannerListenerService: BannerListenerService;
    private _cmpIabService: CmpIABService;
    private _cmpJSApi: CmpJSApi;
    private _crossDomainConsentSharingService: CrossDomainConsentSharingService;
    private _initTime: any;
    public isEUUser: boolean | undefined = undefined;
    public isConsentChangeAllow = true;

    get crossDomainConsentSharingService() {
        return this._crossDomainConsentSharingService;
    }

    set crossDomainConsentSharingService(crossDomainConsentSharingService) {
        this._crossDomainConsentSharingService = crossDomainConsentSharingService;
    }

    get cmpIABService() {
        return this._cmpIabService;
    }

    set cmpIABService(cmpIABService) {
        this._cmpIabService = cmpIABService;
    }

    get cmpJSApi() {
        return this._cmpJSApi;
    }

    set cmpJSApi(cmpJSApi) {
        this._cmpJSApi = cmpJSApi;
    }

    constructor() {
        this.initInConstructor();

        if (DataService.getLocalStorage('developmentEnvironment') === 'yes') {
            this.isDevelopmentMode = true;
        }

        this.beforeCloseTabEvent = this.beforeCloseTabEvent.bind(this);
        if (
            !this.userAgentService.detectIE() ||
            this.userAgentService.detectIE() > 9
        ) {
            this._initTime = window.performance.now();
        }
        this.developmentLog(
            'We will be printing a timestamp in milliseconds in front of each message, so you can also see the order and the speed of each step'
        );

        let localCount = Number(
            DataService.getLocalStorage('curentOpenedDomainCounter') || '0'
        );
        localCount = localCount < 0 ? 1 : localCount + 1;
        DataService.storeToLocalStorage(
            'curentOpenedDomainCounter',
            localCount.toString()
        );
    }

    set UserCentricViewController(ucViewController) {
        this._ucViewController = ucViewController;
    }

    get UserCentricViewController() {
        return this._ucViewController;
    }

    set languageService(langService) {
        this._languageService = langService;
    }

    get apiService() {
        return this._apiService;
    }

    get userAgentService() {
        return this._userAgentService;
    }

    get moreInfoEventsService() {
        return this._moreInfoEventsService;
    }

    get languageDeciderService() {
        return this._languageDeciderService;
    }

    get optinTeimeoutService() {
        return this._optinTeimeoutService;
    }

    get customFunctionsService() {
        return this._customFunctionsService;
    }

    get anchorTagService() {
        return this._anchorTagService;
    }

    get customEmbedService() {
        return this._customEmbedService;
    }

    get bgOverlayService() {
        return this._bgOverlayService;
    }

    get bannerListenerService() {
        return this._bannerListenerService;
    }

    initInConstructor() {
        this._customEmbedService = new CustomEmbedService(this);
        this.cmpIABService = new CmpIABService(this);
        this.cmpJSApi = new CmpJSApi(this);
        this._apiService = new ApiService(this);
        this.crossDomainConsentSharingService = new CrossDomainConsentSharingService(this);
        this._languageDeciderService = new LanguageDeciderService(this);
        this._userAgentService = new UserAgentService();
        this._bannerListenerService = new BannerListenerService();
        this._settingsService = new SettingsService(this);
        this.initializeConsentsService = new InitializeConsentsService(this);
        this.consentsStatusService = new ConsentsStatusService();
        this.consentsToggleService = new ConsentsToggleService();
        this.getConsentsService = new GetConsentsService();
        this.saveConsentsService = new SaveConsentsService(this);
        this.cDCSyncService = new CDCSyncService(this);
        this.historyLabelService = new HistoryLabelService(this);
        this._bgOverlayService = new BgOverlayService(this);
        this._anchorTagService = new AnchorTagService(this);
        this._tagLoggerService = new TagLoggerService(this);
        this._moreInfoEventsService = new MoreInfoEventsService(this);
        this._optinTeimeoutService = new OptinTeimeoutService(this);
        new WindowUsercentricsService(this);
        this._customFunctionsService = new CustomFunctionsService(this);
    }

    initOnGetSetting() {
        this.languageService = new LanguageService(this);
        this.optinTeimeoutService.setTimerForAgreement();
        this.historyLabelService.momentUpdateLocale();
        /**
         * var eventName = this._userAgentService.isIosMobile
         *  ? "pagehide"
         *   : "beforeunload";
         * window.addEventListener(eventName, this.beforeCloseTabEvent, false);
         */
    }

    onViewInit() {
        this.customFunctionsService.activateFunctionsOnEventsListener();
        this.hostHashUrlChangeListener();
        window.addEventListener('beforeunload', () => {
            this.beforeCloseTabEvent();
        });
        window.usercentrics.onViewInit();
        window.usercentrics.isInitialized = true;
    }

    onUpdateView() {
        this.customFunctionsService.adjustBodyPadding();
    }

    get settingsService() {
        return this._settingsService;
    }

    get languageService() {
        return this._languageService;
    }

    get tagLoggerService() {
        return this._tagLoggerService;
    }

    beforeCloseTabEvent() {
        this.developmentLog('inside beforeCloseTab');
        if (this._settingsService.settings.tagLoggerIsActive) {
            let count = 0;
            const localCount = Number(
                DataService.getLocalStorage('curentOpenedDomainCounter')
            );
            if (localCount) {
                count = localCount - 1;
                DataService.storeToLocalStorage(
                    'curentOpenedDomainCounter',
                    count.toString()
                );
            } else {
                count = 0;
                DataService.storeToLocalStorage(
                    'curentOpenedDomainCounter',
                    count.toString()
                );
            }
            if (count === 0) {
                this._tagLoggerService.updateLog();
            }
        }
    }

    hostHashUrlChangeListener() {
        window.addEventListener('click', (event: any) => {
            const target = event.target;
            this._anchorTagService.initHandle(target, event);
        });
    }

    prepareTimeStamp() {
        if (
            this.userAgentService.detectIE() > 0 &&
            this.userAgentService.detectIE() < 10
        ) {
            return '';
        }
        let output = (
            Math.round(window.performance.now() - this._initTime) % 10000
        ).toString();
        while (output.length !== 4) {
            output = '0' + output;
        }
        return output + ' ';
    }

    developmentLog(data, obj?) {
        if (this.isDevelopmentMode) {
            if (obj) {
                console.log(this.prepareTimeStamp() + data, obj);
            } else {
                console.log(this.prepareTimeStamp() + data);
            }
        }
    }

    static developomentTrace() {
        const isDev = DataService.getLocalStorage('developmentEnvironment');
        if (isDev && isDev === 'yes') {
            console.trace();
        }
    }

    public useIabTemplate(): boolean {
        const TCF_WHITELIST: string[] = ['xxtDfZBDd', 'ry97BZSXX', '7-61Md4v8'];
        return (this.settingsService.settings.iabConsentIsActive
            && TCF_WHITELIST.indexOf(this.settingsService.settings.settingsId) > -1);
    }

    public toggleDevelopmentMode(): string {
        if (this.isDevelopmentMode) {
            this.isDevelopmentMode = false;
            DataService.storeToLocalStorage('developmentEnvironment', 'no');
            return 'development mode is turned off';
        }
        this.isDevelopmentMode = true;
        DataService.storeToLocalStorage('developmentEnvironment', 'yes');
        this.developmentLog(
            'We will be printing a timestamp in milliseconds in front of each message, so you can also see the order and the speed of each step'
        );
        return 'development mode is turned on';
    }

    public setTypeOfScriptTagForConsents(consents) {
        _.forEach(consents, (consent, j, consents) => {
            this.setTypeOfScriptTagForConsent(consent);
        });
    }

    public setTypeOfScriptTagForConsent(consent) {
        const scriptList = document.getElementsByTagName('script');
        const consentTemplate = GetConsentsService.getAppropriateTemplate(consent.templateId, consent.version);

        if (scriptList && consent && consentTemplate && consentTemplate.dataProcessors) {
            
            for (let divI = 0; divI < scriptList.length; divI++) {
                
                if (scriptList[divI].getAttribute('data-usercentrics') === consentTemplate.dataProcessors[0]) {
                    
                    if (consent.unsavedConsentStatus && scriptList[divI].getAttribute('Type') === 'text/plain') {
                        const node = scriptList[divI];

                        if (this.isTagExecuted[scriptList[divI].getAttribute('src')]) {
                            node.setAttribute('Type', 'text/javascript');
                            return;
                        }

                        const parentNode = scriptList[divI].parentNode;
                        const newNode = document.createElement('script');
                        
                        node.getAttributeNames().forEach(attribute => {
                            newNode.setAttribute(attribute, node.getAttribute(attribute));
                        });
                        
                        newNode.setAttribute('Type', 'text/javascript');
                        if (scriptList[divI].getAttribute('src')) {
                            this.isTagExecuted[scriptList[divI].getAttribute('src')] = true;
                        } else if (node.innerText) {
                            newNode.innerText = node.innerText;
                        }

                        parentNode.removeChild(node);
                        parentNode.appendChild(newNode);
                    } else if (!consent.unsavedConsentStatus) {
                        scriptList[divI].setAttribute('Type', 'text/plain');
                    } else if (scriptList[divI].getAttribute('src')) {
                        this.isTagExecuted[scriptList[divI].getAttribute('src')] = true;
                    }
                }
            }
        }
    }

}
